import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { BankingCustomerFilters, BankingCustomerQueryParams, BankingCustomerType } from '../banking.model';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { EnumHelper } from 'common';

@Component({
    selector: 'ifb-banking-customer-list-filter-dialog',
    templateUrl: './banking-customer-list-filter-dialog.component.html',
    standalone: false
})
export class BankingCustomerListFilterDialogComponent {
  form: UntypedFormGroup;
  bankCustomerTypeOptions = EnumHelper.getNamesAndValues(BankingCustomerType);

  constructor(public dialogRef: MatDialogRef<BankingCustomerListFilterDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private formBuilder: UntypedFormBuilder
  ) {
    this.form = this.formBuilder.group({
      username: this.data.query.username || undefined,
      name: this.data.query.name || undefined,
      type: this.data.query.type || undefined,
    });
  }

  static show(dialog: MatDialog, query: BankingCustomerQueryParams): Observable<any> {
    return dialog.open(BankingCustomerListFilterDialogComponent, {
      data: { query },
      closeOnNavigation: true,
    }).afterClosed();
  }

  onConfirmed(formValues: unknown): void {
    this.dialogRef.close(new BankingCustomerFilters(formValues));
  }
}
